import { SerializedStyles } from '@emotion/core';

export enum AlertMessageType {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  INFO = 'info',
  LIVE_EVENT = 'liveEvent',
}

export interface AlertMessageProps {
  type: AlertMessageType;
  message?: string;
  header?: string;
  iconClass?: string;
  button?: JSX.Element;
  extraStyles?: SerializedStyles;
  duration?: number;
  onClose?: (...args: any[]) => void;
  customColor?: string;
  customElement?: {
    component: string;
    props?: any;
  };
}
